
export const DATE_TIME_FORMAT = 'MM/dd/yyyy h:mm aa';
